import * as constants from './constants';

export const diagInitialState = {
  overview: null,
  diagFaults: {},
  faults: {},
  sensors: null,
  allDiagFaults: null,
};

const diagReducer = (state = diagInitialState, { type, payload } = {}) => {
  switch (type) {
    case constants.GET_DIAG_OVERVIEW:
      return {
        ...state,
        overview: payload,
      };
    case constants.GET_DIAG_ID_FAULTS:
      return {
        ...state,
        diagFaults: {
          ...state.diagFaults,
          ...payload,
        },
      };
    case constants.GET_DIAG_FAULTS_ID:
      return {
        ...state,
        faults: {
          ...state.faults,
          ...payload,
        },
      };
    case constants.GET_SENSORS:
      return {
        ...state,
        sensors: payload,
      };
    case constants.GET_ALL_FAULTS:
      return {
        ...state,
        allDiagFaults: payload,
      };
    default:
      return state;
  }
};

export default diagReducer;
